import PreSignUp from "./presignup";

const SEPTEMBER_13_2024_UTC = new Date(Date.UTC(2024, 8, 13));

export default class PreSignUpAdmin extends PreSignUp {
    constructor() {
        super();
    }

    filterStartingFromSept13(job) {
        if (!job || !job.start_date) {
            return false;
        }

        const startDate = new Date(job.start_date);
        if (Number.isNaN(startDate.getTime())) {
            return false;
        }

        // Keep jobs that start on or after Sept 13, 2024 and have not yet ended.
        if (startDate.getTime() < SEPTEMBER_13_2024_UTC.getTime()) {
            return false;
        }

        if (!job.end_date) {
            return true;
        }

        const now = new Date();
        const endDate = new Date(job.end_date);
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);

        const utcEndDate = new Date(endDate.toUTCString().slice(0, -4));
        return utcEndDate.getTime() > yesterday.getTime();
    }

    async getJobs(accountId) {
        await this.getClientSideToken();
        let res = await this.api.getJobsForAccount(accountId);

        let jobs = res.data
            .filter((job) => this.filterStartingFromSept13(job))
            .sort(this.sortAscByStartDate);

        this.storeLocally("accountId", accountId);
        this.storeLocally("jobs", JSON.stringify(jobs));
        return jobs;
    }
}
